import styled, { keyframes } from 'styled-components';

const ldsDualRing = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SpinnerWhite = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;

  &:after {
    content: " ";
    display: block;
    width: 15px;
    height: 15px;
    margin-top: 2px;
    margin-left: 3px;
    border-radius: 50%;
    border: 4px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: ${ldsDualRing} 1.2s linear infinite;
  }
`;

export const SpinnerBlack = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;

  &:after {
    content: " ";
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 4px solid #000;
    border-color: #000 transparent #000 transparent;
    animation: ${ldsDualRing} 1.2s linear infinite;
  }
`;